import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NewVitalForm from "./NewVital";
import LoadingSpinner from "../../../../partials/loading";
import { LIST, CREATE } from "../../../../queries/vital.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { ReadData } from "../../../../providers/Patient.Provider";
import VitalList from "./VitalList";
import PatientVitalDetail from "./VitalDetial";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

function PatientVitals({ location, match }) {
    // local state
    const [newItem, setNewItem] = useState(false);
    const [activeItem, setActiveItem] = useState(null);

    const patient = ReadData();
    const title = "Patient Vitals";
    const { id } = match.params;
    /**
     * A function that scrolls the page to top
     */
    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    // query
    const { loading, data } = useQuery(LIST, {
        variables: {
            id: patient.lastAdmission || id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // New
    const [PostCreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { RecordNewVital } }) {
            const { GetPatientVitals } = caches.readQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || id,
                },
            });
            GetPatientVitals.docs.unshift(RecordNewVital.doc);
            caches.writeQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || id,
                },
                data: {
                    GetPatientVitals,
                },
            });
        },
        onCompleted: (d) => {
            if (d.RecordNewVital) {
                const { message } = d.RecordNewVital;
                toast.success(message);
            }
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            {!newItem && !activeItem && (
                <div className="col-md-12 col-sx-12 fade-in">
                    <div className="card m-t-20">
                        <div className="card-head">
                            <header>Patient Vitals</header>
                            <div className="float-right mt-2 mr-2">
                                <button
                                    type="button"
                                    onClick={() => {
                                        scrollTop();
                                        setNewItem(true);
                                        setActiveItem(null);
                                    }}
                                    data-toggle="tab"
                                    className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
                                >
                                    <i className="material-icons"> add</i> New Vital
                                </button>
                            </div>
                        </div>
                        <div className="card-body m-t-20" style={{ minHeight: "420px" }}>
                            <LoadingSpinner loading={loading} />
                            {!loading && (
                                <VitalList
                                    items={data && data.GetPatientVitals.docs}
                                    onView={(item) => {
                                        setNewItem(false);
                                        scrollTop();
                                        setActiveItem(item);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
            {newItem && !activeItem && (
                <div className="col-md-12 col-xs-12 fade-in">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button
                                    onClick={() => {
                                        setNewItem(false);
                                        setActiveItem(null);
                                        scrollTop();
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                Record New Vitals
                            </header>
                        </div>
                        <div className="card-body m-b-20">
                            <NewVitalForm
                                onCancel={() => {
                                    setNewItem(false);
                                    setActiveItem(null);
                                    scrollTop();
                                }}
                                onSubmit={async (item) => {
                                    const { id, lastAdmission } = patient;
                                    await PostCreateFunc({
                                        variables: {
                                            model: {
                                                ...item,
                                                admission: lastAdmission,
                                                patient: id,
                                            },
                                        },
                                    });
                                    setTimeout(() => {
                                        setNewItem(false);
                                        setActiveItem(null);
                                        scrollTop();
                                    }, 500);
                                }}
                            />
                            <LoadingSpinner loading={cLoading} />
                        </div>
                    </div>
                </div>
            )}

            {!newItem && activeItem && (
                <div className="col-md-12 fade-in">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button
                                    onClick={() => {
                                        setNewItem(false);
                                        setActiveItem(null);
                                        scrollTop();
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                Patient Vital Detail
                            </header>
                        </div>
                        <div className="card-body m-b-20">
                            <PatientVitalDetail item={activeItem} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PatientVitals;
